/**
 * IMPORTS
 */

import { Trash2, X } from "lucide-react";

// typings
import { IModalExcluirUsuarioDoCliente } from "@pages/admin/gerenciar-usuarios-cliente/components/modal-excluir-usuario-do-cliente/interface";

// hooks - usuarios-cliente - tansTack
import { useExcluirUsuarioCliente } from "@/hooks/usuarios-cliente/excluir-usuario-cliente";

// components
import { Button } from "@/presentation/components/button/button";
import { SpinnerSimple } from "@/presentation/components/spinner-simple/spinner-simple";

// store-zustand
import { useStoreZustandUsuarioCliente } from "@/store-zustand/usuarios-do-clientes";

function ModalExcluirUsuarioDoCliente({ onCancel }: IModalExcluirUsuarioDoCliente) {
  const { usuarioClienteSelecionado } = useStoreZustandUsuarioCliente();
  const { excluirUsuarioClienteAsync, isLoading } = useExcluirUsuarioCliente();

  /**
   * Função responsável por excluir o usuário do cliente.
   */
  const handleExcluirUsuarioCliente = async () => {
    await excluirUsuarioClienteAsync({
      user_id: Number(usuarioClienteSelecionado?.id),
    });

    onCancel();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="relative w-full max-w-md space-y-5 rounded-lg bg-white p-6 shadow-lg">
        <div className="flex justify-between">
          <h3 className="flex text-left text-lg font-semibold text-gray-800">
            <Trash2 className="mr-2" /> Confirmar exclusão?
          </h3>

          <button
            onClick={onCancel}
            className="absolute right-3 text-gray-500 hover:text-gray-800"
            aria-label="Fechar modal"
          >
            <X size={20} />
          </button>
        </div>
        <p className="text-left text-sm text-gray-600">
          Você tem certeza de que deseja excluir permanentemente o usuário{" "}
          <strong className="text-orange-500">{usuarioClienteSelecionado?.nome}</strong>
          ?<br />
          Esta ação não poderá ser desfeita.
        </p>

        <div className="mt-4 flex w-full justify-between gap-4">
          <Button
            disabled={isLoading}
            variant="secondary"
            className="w-full rounded-md bg-gray-200 px-4 py-2 text-gray-700 hover:bg-gray-300"
            onClick={onCancel}
          >
            Cancelar
          </Button>
          <Button
            disabled={isLoading}
            variant="default"
            className="w-full bg-red-600 px-4 py-2 text-white hover:bg-red-700"
            onClick={handleExcluirUsuarioCliente}
          >
            {isLoading ? <SpinnerSimple /> : "Excluir usuário"}
          </Button>
        </div>
      </div>
    </div>
  );
}

/**
 * EXPORT
 */
export { ModalExcluirUsuarioDoCliente };
